import toast from "react-hot-toast";
import * as api from "../Api";
import { approvedInvestments } from "./approvedInvestment";
import { approvedUndefinedInvestments } from "./approvedUndefinedInvestments";
import { getAllInvestment } from "./investment";
import { getInstitutionStats } from "./institutionStats";
import { monthStats } from "./monthStats";
import { yearStats } from "./yearStats";

// The server's own message ("You entered this investment...") beats axios's
const errorMessage = (error) =>
  error?.response?.data?.message || error?.message || "Something went wrong";

export const newInvestments = () => async (dispatch) => {
  try {
    const { data } = await api.newInvestments();
    dispatch({ type: "NEW_INVESTMENTS", payload: data });
  } catch (error) {}
};

export const createNewInvestment = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Submitting investment for approval...");
    const { data } = await api.createInvestment(postData);
    dispatch({ type: "CREATE_NEW_INVESTMENT", payload: data });
    toast.remove(creatingId);
    toast.success("Submitted for approval");
    return data;
  } catch (error) {
    toast.remove(creatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const approveNewInvestment = (id) => async (dispatch) => {
  let approvingId;
  try {
    approvingId = toast.loading("Approving investment...");
    const res = await api.approveInvestment(id);
    dispatch({ type: "APPROVE_NEW_INVESTMENT", payload: id });
    // The approved investment now belongs on the dashboard and reports
    dispatch(approvedInvestments());
    dispatch(approvedUndefinedInvestments());
    dispatch(getAllInvestment());
    dispatch(monthStats());
    dispatch(yearStats());
    dispatch(getInstitutionStats());
    toast.remove(approvingId);
    toast.success("Investment approved");
    return res;
  } catch (error) {
    toast.remove(approvingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const returnNewInvestment = (id, reason) => async (dispatch) => {
  let returningId;
  try {
    returningId = toast.loading("Returning investment...");
    const { data } = await api.returnInvestment(id, reason);
    dispatch({ type: "EDIT_NEW_INVESTMENT", payload: data });
    toast.remove(returningId);
    toast.success("Returned for correction");
    return data;
  } catch (error) {
    toast.remove(returningId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const editNewInvestment = (id, postData) => async (dispatch) => {
  let updatingId;
  try {
    updatingId = toast.loading("Saving Changes...");
    const { data } = await api.updateInvestment(id, postData);
    dispatch({ type: "EDIT_NEW_INVESTMENT", payload: data });
    toast.remove(updatingId);
    toast.success("Changes saved");
    return data;
  } catch (error) {
    toast.remove(updatingId);
    toast.error(errorMessage(error));
    throw error;
  }
};

export const deleteInvestment = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting Investment..");
    const res = await api.deleteInvestment(id);
    dispatch({ type: "DELETE_NEW_INVESTMENT", payload: id });

    toast.remove(deletingId);
    toast.success("Investment Successfully deleted");
    return res;
  } catch (error) {
    toast.remove(deletingId);
    toast.error(errorMessage(error));
    throw error;
  }
};
